'use client';

import { InputHTMLAttributes, TextareaHTMLAttributes, forwardRef } from 'react';
import styles from './Input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    hint?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, error, hint, className = '', id, ...props }, ref) => {
        const inputId = id || `input-${Math.random().toString(36).slice(2, 9)}`;

        return (
            <div className={styles.formGroup}>
                {label && (
                    <label htmlFor={inputId} className={styles.label}>
                        <span className={styles.dimText}>// </span>
                        {label}
                        {props.required && <span className={styles.required}> *</span>}
                    </label>
                )}
                <input
                    ref={ref}
                    id={inputId}
                    className={`${styles.input} ${error ? styles.inputError : ''} ${className}`}
                    {...props}
                />
                {hint && !error && <span className={styles.hint}>{hint}</span>}
                {error && <span className={styles.error}>{error}</span>}
            </div>
        );
    }
);

Input.displayName = 'Input';

export default Input;

// Textarea variant
export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ label, error, hint, className = '', id, ...props }, ref) => {
        const textareaId = id || `textarea-${Math.random().toString(36).slice(2, 9)}`;

        return (
            <div className={styles.formGroup}>
                {label && (
                    <label htmlFor={textareaId} className={styles.label}>
                        <span className={styles.dimText}>// </span>
                        {label}
                        {props.required && <span className={styles.required}> *</span>}
                    </label>
                )}
                <textarea
                    ref={ref}
                    id={textareaId}
                    className={`${styles.textarea} ${error ? styles.inputError : ''} ${className}`}
                    {...props}
                />
                {hint && !error && <span className={styles.hint}>{hint}</span>}
                {error && <span className={styles.error}>{error}</span>}
            </div>
        );
    }
);

Textarea.displayName = 'Textarea';
